import React from 'react';
import DOMPurify from 'dompurify';


export function HTMLDescription({ description }) {
  const cleanHTML = DOMPurify.sanitize(description);
  return (
    <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
  );
}